import React from "react";

export const SectionHeading = ({ eyebrow, title, intro, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-brand-leafDeep bg-brand-honey/40 border border-brand-sun/30 rounded-full px-4 py-1.5 mb-6">
        <span className="h-1.5 w-1.5 rounded-full bg-brand-sun" />
        {eyebrow}
      </p>
    )}
    <h2 className="font-heading font-normal text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-brand-ink">
      {title}
    </h2>
    {intro && (
      <p className="mt-5 text-brand-muted text-base leading-relaxed font-body">
        {intro}
      </p>
    )}
  </div>
);
